import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type TJsonQuery } from '@/packages/JsonQuery';

import { JSON_QUERY_DEFAULT } from '../../constants/jsonQuery';

export type TJsonQueryState = {
  current: TJsonQuery;
};

const jsonQueryInitialState: TJsonQueryState = {
  current: JSON_QUERY_DEFAULT,
};

export const jsonQuerySlice = createSlice({
  initialState: { ...jsonQueryInitialState },
  name: 'jsonQuery',
  reducers: {
    change(state, action: PayloadAction<TJsonQuery>) {
      state.current = action.payload;
    },
  },
});

export const { reducer: jsonQueryReducer, actions: jsonQueryActions } = jsonQuerySlice;
